import constants from '../../../constants';

export interface HeaderOptions {
  apiKey?: string;
  sessionKey?: string;
}

interface StoredSession {
  key?: string;
}

function readSessionKeyFromStorage(): string | undefined {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem('session') : null;
    if (!raw || raw === 'undefined') return undefined;
    const parsed = JSON.parse(raw) as StoredSession;
    return parsed?.key;
  } catch {
    return undefined;
  }
}

export function getHeaders(options: HeaderOptions = {}): Record<string, string> {
  const apiKey = options.apiKey ?? constants.apikey ?? '';
  const sessionKey = options.sessionKey ?? readSessionKeyFromStorage() ?? '';
  const headers: Record<string, string> = {
    ApiKey: apiKey,
    'Content-Type': 'application/json',
  };
  // Omit Authorization entirely when no session — sending `Authorization: ""`
  // can trip proxies / WAFs that treat empty differently from missing.
  if (sessionKey) {
    headers.Authorization = `bearer ${sessionKey}`;
  }
  return headers;
}

export function getApiBase(): string {
  return constants.baseApiHost ?? '';
}
